module.exports = __webpack_public_path__ + "img/bot-img-progress.38489f43.png";